import { Component, ComponentFactoryResolver, ViewContainerRef, Inject, OnDestroy, OnInit, Type, ViewChild, Injector } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { ChangeCollisionDialogComponentService } from './change-collision-dialog-component-service';

@Component({
  selector: 'app-change-collision-dialog',
  templateUrl: './change-collision-dialog.component.html',
  styleUrls: ['./change-collision-dialog.component.css'],
  providers: [
    ChangeCollisionDialogComponentService
  ]
})
export class ChangeCollisionDialogComponent implements OnDestroy, OnInit {

  private _diffOuter = new ReplaySubject<ViewContainerRef>();
  @ViewChild('diffOuter', { read: ViewContainerRef }) set diffOuter(element: ViewContainerRef){
    this._diffOuter.next(element);
  }

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ChangeCollisionDialogComponentInputData,
    private _changeCollisionDialogComponentService : ChangeCollisionDialogComponentService,
    private _componentFactoryResolver: ComponentFactoryResolver
  ) { }

  close(){
    window.location.reload();
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._changeCollisionDialogComponentService.setOldStatus(this.data.localState);
    this._subscriptions.push(...[
      this.data.objectProvider(this.data.externalChange.identifier).subscribe((object) => this._changeCollisionDialogComponentService.setNewStatus(object)),
      this._diffOuter.subscribe((viewContainerRef: ViewContainerRef) => this.loadInner(viewContainerRef))
    ]);
  }

  loadInner(viewContainerRef: ViewContainerRef){
    viewContainerRef.clear();
    let factory = this._componentFactoryResolver.resolveComponentFactory(this.data.inner);
    viewContainerRef.createComponent(factory, null, Injector.create({
      providers: [
        { provide: ChangeCollisionDialogComponentService, useValue: this._changeCollisionDialogComponentService }]
    }));
  }

  overwrite = () => {

  }

}

export class ChangeCollisionDialogComponentInputData {
  localState: any;
  typeName: string;
  externalChange: { date: string, user: string, identifier: number, message: string };
  objectProvider: (identifier: number) => Observable<any>;
  inner: Type<any>;
}
